class OmegaProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-omega-main-image]');
    this.buttons = [...this.querySelectorAll('[data-omega-gallery-thumb]')];
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
  }

  select(button) {
    if (!this.mainImage) return;

    const source = button.dataset.imageSrc;
    const alt = button.dataset.imageAlt || '';
    if (!source) return;

    this.mainImage.src = source;
    this.mainImage.srcset = '';
    this.mainImage.alt = alt;
    this.buttons.forEach((item) => item.setAttribute('aria-current', String(item === button)));
  }
}

class OmegaBundleSelector extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.root = this.closest('.omega-pdp-hero') || document;
    this.quantityInput = this.form ? this.form.querySelector('[data-omega-quantity]') : null;
    this.variantInput = this.form ? this.form.querySelector('.product-variant-id') : null;
    this.priceEl = this.root.querySelector('[data-omega-price]');
    this.perBottleEl = this.root.querySelector('[data-omega-perbottle]');
    this.submit = this.form ? this.form.querySelector('button[name="add"]') : null;
    this.radios = [...this.querySelectorAll('input[type="radio"]')];
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.sync(radio)));
    const selected = this.radios.find((radio) => radio.checked) || this.radios[0];
    if (selected) {
      selected.checked = true;
      this.sync(selected);
    }
  }

  sync(radio) {
    const variantId = radio.dataset.variantId;

    if (variantId) {
      // Variant-pack mode: each radio is a real Shopify variant (1 / 3 / 5 bottles).
      const available = radio.dataset.available !== 'false';
      if (this.variantInput) {
        this.variantInput.value = variantId;
        this.variantInput.disabled = !available;
      }
      if (this.quantityInput) this.quantityInput.value = '1';
      if (this.priceEl) {
        const compare = radio.dataset.compare;
        this.priceEl.innerHTML =
          radio.dataset.price + (compare ? ' <s>' + compare + '</s>' : '');
      }
      if (this.perBottleEl && radio.dataset.perbottle) {
        this.perBottleEl.textContent = radio.dataset.perbottle;
      }
      if (this.submit) this.submit.disabled = !available;
    } else if (this.quantityInput) {
      // Legacy fallback: radio value is a quantity multiplier.
      this.quantityInput.value = radio.value;
    }

    this.radios.forEach((item) => {
      const label = item.closest('.omega-bundle');
      if (label) label.classList.toggle('is-selected', item.checked);
    });
  }
}

if (!customElements.get('omega-product-gallery')) {
  customElements.define('omega-product-gallery', OmegaProductGallery);
}

if (!customElements.get('omega-bundle-selector')) {
  customElements.define('omega-bundle-selector', OmegaBundleSelector);
}
